import { Alert, Box } from "@mui/material";
import React from "react";

const ApologyForMonthError = () => {
  return (
    <Box
      sx={{
        maxWidth: "460px",
        margin: "4px auto auto",
      }}
    >
      <Alert severity="info" sx={{

      }}>
        お詫びとご報告<br />
        <br />
        平素より当サービスをご利用いただき、<br />誠にありがとうございます。<br />
        <br />
        このたび、当サービスの実績表示において、<br />昨年同月の実績が今月の実績として誤って表示される不具合が発生していたことが判明しました。<br />対象期間は以下の通りです。<br />
        <br />
        •	誤表示の期間: 2024年10月1日 ～ 2024年12月4日<br />
        •	問題解消日時: 2024年12月4日 12:00<br />
        <br />
        現在は、正しい情報が表示されるよう修正を完了しております。<br />
        長期間にわたり誤った情報を表示していたこと、<br />そして皆さまにご迷惑をおかけしましたことを深くお詫び申し上げます。<br />
        <br />
        今後、同様の問題が発生しないよう<br />再発防止に努めてまいります。<br />
        何卒ご理解いただけますようお願い申し上げます。<br />
      </Alert>
    </Box>
  );
};

export default ApologyForMonthError;
